import React from 'react';

/**
 * Shown when Plan route includes /lessons/assess (no URL-driven editor shells).
 * Unit-card edit flows use EditAssessment inline on In Progress.
 */
export function AssessmentEditorContent() {
  return (
    <div className="space-y-4">
      <div className="text-center py-12">
        <p className="text-gray-600">No assessment selected. Edit assessments from the In Progress tab.</p>
      </div>
    </div>
  );
}
